import Field from 'quickfield/dist/field'
import TextField from 'quickfield/dist/fields/text'
import template,* as templates from './template'
import SimplyBind from '@danielkalen/simplybind'
import quickpopup from 'quickpopup'
import Croppie from 'croppie'


class ImageField extends Field
	template: template
	templates: templates
	defaults:
		size: 60
	
	constructor: ()->
		super(arguments...)
		@_value ?= ''
		@_createElements()
		@_attachBindings()
		@_constructorEnd()


	_getValue: ()->
		return @_value

	_setValue: (input)->
		@_value = input

	_createElements: ()->
		@el = @template.spawn(@settings.templates.default, related:@)
		@editPopup = quickpopup templates.editPopup.spawn(null, related:@)
		@croppie = new Croppie @editPopup.content.child.cropContainer.raw,
			enableOrientation: true
			showZoomer: true
			boundary:
				height: 400
			viewport:
				width: 200
				height: 200

		return @el


	_attachBindings: ()->
		@_attachBindings_elState()

		SimplyBind('_value').of(@).to (src)=>
			@state.filled = !!src
			@emit 'input', @_value
			if src
				@el.child.img.attr 'src', src
				@el.child.img.show()
			else
				@el.child.img.hide()

		SimplyBind('width').of(@state)
			.to (width)=> @el.style 'width', @_formatWidth(width)
			.updateOn('isMobile').of(@state)

		SimplyBind('isMobile').of(@state)
			.to (width)=> @el.style 'width', @_formatWidth(width)

		SimplyBind('event:change').of(@el.child.input)
			.to (e)=> @handleInputChange()
		
		SimplyBind('event:click').of(@el.child.remove)
			.to (e)=>
				e.stopPropagation()
				@_value = ''
		
		SimplyBind('event:close').of(@editPopup)
			.to (e)=> @el.child.input.raw.value = '' 

	
	_validate: (value)->
		return !!value

	handleInputChange: ()->
		input = @el.child.input.raw
		if input.files?[0]
			reader = new FileReader()
			
			reader.addEventListener 'load', (e)=>
				imgData = e.target.result
				@croppie.bind url:imgData
				@editPopup.open()

			reader.readAsDataURL(input.files[0])
	
	updateFromCroppie: ()->
		result = await @croppie.result 'base64'
		@_value = result
		@editPopup.close()
	

	@::_attachBindings_elState = TextField::_attachBindings_elState


export default ImageField